import script from "./MarqueeWrapperComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarqueeWrapperComponent.vue?vue&type=script&setup=true&lang=ts"

import "./MarqueeWrapperComponent.vue?vue&type=style&index=0&id=5de2cd1a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5de2cd1a"]])

export default __exports__